import { InAppBrowser } from '@capgo/inappbrowser';
import { XIMI_NATIVE_REDIRECT_URI } from './oidcConfig';

/**
 * Native only. Opens an SSO URL (`/authorize` or `end_session`) in an in-app webview and
 * resolves with the redirect URL as soon as navigation hits `redirectMatch`
 * (an https URL never actually loaded, e.g. `https://localhost/...`), or null if closed.
 * `redirectMatch` défaut = callback login ; le logout passe l'URI post-logout.
 *
 * Mirrors Ximi Famille's `loadstart` interception — `urlChangeEvent`/`closeEvent` are
 * only emitted by `openWebView` (not `open`).
 */
export async function openXimiAuthBrowser(
    url: string,
    redirectMatch: string = XIMI_NATIVE_REDIRECT_URI
): Promise<string | null> {
    let resolveResult!: (value: string | null) => void;
    const result = new Promise<string | null>((resolve) => {
        resolveResult = resolve;
    });

    const urlHandle = await InAppBrowser.addListener('urlChangeEvent', ({ url: current }) => {
        if (current.startsWith(redirectMatch)) resolveResult(current);
    });
    const closeHandle = await InAppBrowser.addListener('closeEvent', () => resolveResult(null));

    await InAppBrowser.openWebView({ url });

    const callbackUrl = await result;
    await urlHandle.remove();
    await closeHandle.remove();
    if (callbackUrl) await InAppBrowser.close();
    return callbackUrl;
}
